import React, { useState, useEffect, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { name } from '../constants';
import Background from './Background';
import ButtonLink from './ButtonLink';

const Home = () => {
	const sectionRef = useRef(null);
	const ref = useRef(0);
	const [text, setText] = useState('');
	const fullName = typeof name === 'string' ? name : '';

	const { scrollY } = useScroll();
	const heroY = useTransform(scrollY, [0, 420], [0, -110]);
	const heroOpacity = useTransform(scrollY, [0, 320], [1, 0.25]);
	const heroScale = useTransform(scrollY, [0, 420], [1, 0.96]);
	const bgOpacity = useTransform(scrollY, [0, 520], [1, 0.6]);

	useEffect(() => {
		ref.current = 0;
		setText('');

		if (!fullName) return;

		const interval = setInterval(() => {
			const nextChar = fullName.charAt(ref.current);
			if (!nextChar) {
				clearInterval(interval);
				return;
			}
			setText((prev) => prev + nextChar);
			ref.current += 1;
		}, 120);

		return () => clearInterval(interval);
	}, [fullName]);

	return (
		<section
			ref={sectionRef}
			id="home"
			className="relative min-h-screen w-screen overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white scroll-mt-24"
		>
			<motion.div style={{ opacity: bgOpacity }}>
				<Background />
			</motion.div>
			<div className="relative z-10 flex min-h-[calc(100vh-88px)] items-center justify-center px-4 pt-[88px] pb-12">
				<motion.div
					style={{ y: heroY, opacity: heroOpacity, scale: heroScale }}
					className="max-w-4xl text-center space-y-6 reveal-on-scroll"
				>
					<h1 className="text-4xl sm:text-6xl md:text-7xl font-extrabold leading-tight">
						Hi, I'm{' '}
						<span className="bg-gradient-to-r from-sky-300 via-teal-300 to-emerald-300 bg-clip-text text-transparent">
							{text || fullName}
						</span>
						<span className="typing-caret" aria-hidden="true" />
					</h1>
					<p className="mx-auto max-w-2xl text-base sm:text-lg text-slate-300">
						EEE undergrad at IIT Patna, exploring the intersection of software, electronics, and impactful products. I love building modern web experiences and learning new technologies along the way.
					</p>
					<div className="flex flex-wrap items-center justify-center gap-4 pt-2">
						<ButtonLink
							url="https://drive.google.com/file/d/1m2ZTJHUnwyqlkCnIYZPEETj_rck9TSSo/view?usp=sharing"
							text="View Resume →"
							padding="px-6 py-3 bg-sky-500/90 hover:bg-sky-400 border-sky-400"
						/>
						<ButtonLink
							url="#projects"
							text="View Projects"
							padding="px-6 py-3 bg-transparent border-slate-600 hover:bg-slate-100 hover:text-black"
						/>
					</div>
				</motion.div>
			</div>
		</section>
	);
};

export default Home;